import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect } from "react";

const Error = () => {
  const navigate = useNavigate();

  // Redirect to home page after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      navigate("/");
    }, 5000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="bg-[#111] text-white min-h-screen flex flex-col justify-center items-center">
      <div className="absolute right-14 top-7 max-md:right-6 max-md:top-4">
        <button
          onClick={() => navigate("/")}
          className="after:border-2 after:border-[#009e66] after:w-4/5 after:h-4/5 after:animate-ping after:ease-out after:absolute after:rounded-full after:right-1 after:top-1"
        >
          <CloseIcon sx={{ fontSize: "38px", color: "#009e66" }} />
        </button>
      </div>
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-6">Oops!</h1>
        <p className="text-lg md:text-xl mb-8">
          It seems like there's an error.
        </p>
        <p className="text-lg md:text-xl mb-8">
          Don't worry, we're redirecting you to the home page.
        </p>
      </div>
    </div>
  );
};

export default Error;
